import { Input, InputProps } from "@chakra-ui/react";
import React, { forwardRef } from "react";

export interface APInputProps extends InputProps {
  error?: string;
  id?: string;
}

const APInput = forwardRef<HTMLInputElement, APInputProps>(
  ({ variant = "flushed", error, id, colorScheme = "tertiary", ...others }, ref) => {
    const isInvalid = !!error;

    return (
      <>
        <Input variant={variant} colorScheme={colorScheme} id={id} isInvalid={isInvalid} {...others} ref={ref} />
        {error != "" && <div className="error">{error}</div>}
      </>
    );
  }
);

export default APInput;
